(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["new-gems-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSlider() {
    const slider = document.getElementById('slider');
    const viewport = document.getElementById('viewport');
    const track = document.getElementById('track');
    const slides = Array.from(track?.children || []);
    const prevBtn = document.getElementById('prev');
    const nextBtn = document.getElementById('next');
    const dotsWrap = document.getElementById('dots');
    const thumbsWrap = document.getElementById('thumbs');

    // ✅ Macro UI elements
    const macroUI = document.getElementById('asMacroUI');
    const macroToggle = document.getElementById('asMacroToggle');
    const macroLens = document.getElementById('asMacroLens');
    const macroHint = document.getElementById('asMacroHint');
    const macroZoomBtn = document.getElementById('asMacroZoom');
    const macroOpenBtn = document.getElementById('asMacroOpen');

    if (!slider || !track || slides.length === 0) return;

    let index = 0;
    let userSelectedMedia = false;
    let slideWidth = viewport.clientWidth;
    const total = slides.length;

    // Macro state
    let macroOn = false;
    let activeImg = null;

    thumbsWrap.innerHTML = '';
    dotsWrap.innerHTML = '';

    const dots = [];
    const thumbs = [];

    slides.forEach((slide, i) => {
      const dot = document.createElement('div');
      dot.className = 'dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', () => { userSelectedMedia = true; goTo(i); });
      dotsWrap.appendChild(dot);
      dots.push(dot);

      const img = slide.querySelector('img');
      if (img) {
        const thumb = img.cloneNode();
        thumb.width = 84;
        thumb.height = 84;
        thumb.className = i === 0 ? 'active' : '';
        thumb.addEventListener('click', () => { userSelectedMedia = true; goTo(i); });
        thumbsWrap.appendChild(thumb);
        thumbs.push(thumb);
      }
    });

    function setTranslate(x, animate = true) {
      track.style.transition = animate ? 'transform 720ms cubic-bezier(.22,.9,.32,1)' : 'none';
      track.style.transform = `translateX(${x}px)`;
    }

    function updateUI() {
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('active', i === index));
    }

    function clampIndex(i) {
      return ((i % total) + total) % total;
    }
 function setActiveMedia(i){
  const slide = slides[i];
  activeImg = slide ? slide.querySelector(':scope > img') : null;
  fitActiveMedia();

  const isImage = !!activeImg;

  // ===== VIDEO / NON-IMAGE =====
  if(!isImage){

    // ❌ turn OFF macro completely
    macroOn = false;

    if(macroLens){
      macroLens.classList.remove('is-on');
      macroLens.style.left = '-9999px'; // move away safely
    }

    if(macroToggle){
      macroToggle.setAttribute('aria-pressed','false');
    }

    if(macroHint){
      macroHint.classList.remove('is-show');
    }

    // 🚨 FULL HIDE (not opacity)
    if(macroUI){
      macroUI.style.display = "none";
      macroUI.style.pointerEvents = "none";
    }

    return;
  }

  // ===== IMAGE SLIDE =====
  if(macroUI){
    macroUI.style.display = "block";
    macroUI.style.pointerEvents = "auto";
  }

  // update macro image
  if(macroLens){
    macroLens.style.backgroundImage =
      `url("${activeImg.currentSrc || activeImg.src}")`;
  }
}


    function fitActiveMedia() {
      const slide = slides[index];
      const media = slide?.querySelector(':scope > img, :scope > video');
      const width = media?.naturalWidth || media?.videoWidth;
      const height = media?.naturalHeight || media?.videoHeight;
      const ratio = width && height ? width / height : Number(slide?.dataset.mediaRatio) || 1;
      const limit = window.innerWidth <= 767
        ? viewport.clientWidth * 1.25
        : Math.min(480, Math.max(320, window.innerHeight * 0.6));
      viewport.style.height = Math.min(viewport.clientWidth / ratio, limit) + 'px';
    }
    slides.forEach(slide => {
      const media = slide.querySelector(':scope > img, :scope > video');
      media?.addEventListener('load', fitActiveMedia);
      media?.addEventListener('loadedmetadata', fitActiveMedia);
    });

    function goTo(i) {
      index = clampIndex(i);
      setTranslate(-index * slideWidth);
      updateUI();
      setActiveMedia(index);
      restartAutoplay();
    }

    if (nextBtn) nextBtn.addEventListener('click', () => { userSelectedMedia = true; goTo(index + 1); });
    if (prevBtn) prevBtn.addEventListener('click', () => { userSelectedMedia = true; goTo(index - 1); });

    // ✅ Drag / Swipe (kept)
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let currentTranslate = 0;
    let isSwiping = false;

    function getEventXY(e) {
      if (e.type.startsWith('touch')) {
        const t = e.touches[0] || e.changedTouches[0];
        return { x: t.clientX, y: t.clientY };
      }
      return { x: e.clientX, y: e.clientY };
    }

    function pointerDown(e) {
      if (e.target.closest('video, iframe, model-viewer')) return;
      if (e.type === 'mousedown' && e.button !== 0) return;
      const { x, y } = getEventXY(e);
      isDragging = true;
      isSwiping = false;
      startX = x;
      startY = y;
      slider.classList.add('grabbing');
      track.style.transition = 'none';
      pauseAutoplay();
      e.preventDefault?.();
    }

    function pointerMove(e) {
      if (!isDragging) return;
      const { x, y } = getEventXY(e);
      const dx = x - startX;
      const dy = y - startY;

      if (!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 5) {
        isSwiping = true;
      }

      if (isSwiping) {
        e.preventDefault?.();
        currentTranslate = -index * slideWidth + dx;
        setTranslate(currentTranslate, false);
      }
    }

    function pointerUp(e) {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove('grabbing');

      if (!isSwiping) {
        restartAutoplay();
        return;
      }

      const { x } = getEventXY(e);
      const moved = x - startX;
      const threshold = Math.max(60, slideWidth * 0.15);

      if (moved > threshold) index -= 1;
      else if (moved < -threshold) index += 1;

      goTo(index);
    }

    track.addEventListener('mousedown', pointerDown);
    window.addEventListener('mousemove', pointerMove);
    window.addEventListener('mouseup', pointerUp);

    track.addEventListener('touchstart', pointerDown, { passive: true });
    track.addEventListener('touchmove', pointerMove, { passive: false });
    track.addEventListener('touchend', pointerUp);
    track.addEventListener('touchcancel', pointerUp);

    // Refit after layout changes as well as window resizes.
    function resizeGallery() {
      fitActiveMedia();
      const width = viewport.clientWidth;
      if (width !== slideWidth) {
        slideWidth = width;
        setTranslate(-index * slideWidth, false);
      }
    }
    window.addEventListener('resize', resizeGallery);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(resizeGallery).observe(viewport);
    }

    // Autoplay
    const AUTOPLAY_DELAY = 3000;
    let autoplayId = null, resumeTimeout = null;

    function startAutoplay() {
      if (autoplayId || userSelectedMedia) return;
      autoplayId = setInterval(() => goTo(index + 1), AUTOPLAY_DELAY);
    }

    function pauseAutoplay() {
      if (autoplayId) { clearInterval(autoplayId); autoplayId = null; }
      if (resumeTimeout) { clearTimeout(resumeTimeout); }
    }

    function restartAutoplay(delay = 1200) {
      pauseAutoplay();
      resumeTimeout = setTimeout(() => startAutoplay(), delay);
    }

    slider.addEventListener('mouseenter', pauseAutoplay);
    slider.addEventListener('mouseleave', () => restartAutoplay(700));

    /* =========================
       ✅ Macro Lens Logic
    ========================= */
    function toggleMacro(force){
      if(!activeImg) return;
      macroOn = typeof force === 'boolean' ? force : !macroOn;

      if(macroLens) macroLens.classList.toggle('is-on', macroOn);
      if(macroToggle) macroToggle.setAttribute('aria-pressed', macroOn ? 'true' : 'false');
      if(macroHint) macroHint.classList.toggle('is-show', macroOn);

      // Set background image (in case slide changed)
      if(macroOn && macroLens){
        macroLens.style.backgroundImage = `url("${activeImg.currentSrc || activeImg.src}")`;
      }
    }

  function lensMove(clientX, clientY){
if(!macroOn || !macroLens || !activeImg || !macroUI || macroUI.style.display === "none") return;

  // ✅ Use macroUI rect (NOT viewport) because macroUI has inset padding
  const uiRect = macroUI.getBoundingClientRect();

  const x = clientX - uiRect.left;
  const y = clientY - uiRect.top;

  // Clamp lens inside macroUI
  const lensW = macroLens.offsetWidth;
  const lensH = macroLens.offsetHeight;

  const lx = Math.max(0, Math.min(uiRect.width - lensW, x - lensW / 2));
  const ly = Math.max(0, Math.min(uiRect.height - lensH, y - lensH / 2));

  macroLens.style.left = lx + "px";
  macroLens.style.top  = ly + "px";

  // ✅ Background position should be 0–100%, not 0–200%
  const px = Math.max(0, Math.min(100, (x / uiRect.width) * 100));
  const py = Math.max(0, Math.min(100, (y / uiRect.height) * 100));

  macroLens.style.backgroundPosition = `${px}% ${py}%`;
}


    // Toggle macro via pill / bullseye
    if(macroToggle){
      macroToggle.addEventListener('click', () => toggleMacro());
    }
    if(macroZoomBtn){
      macroZoomBtn.addEventListener('click', () => toggleMacro());
    }

viewport.addEventListener('mousemove', (e) => {
  if(!macroUI || macroUI.style.display === 'none') return;
  lensMove(e.clientX, e.clientY);
});

viewport.addEventListener('touchmove', (e) => {
  if(!macroUI || macroUI.style.display === 'none') return;
  if(!e.touches || !e.touches[0]) return;
  lensMove(e.touches[0].clientX, e.touches[0].clientY);
}, { passive:true });

    // Optional: show lens only while hovering (desktop)
    viewport.addEventListener('mouseenter', () => { if(macroOn) macroHint && macroHint.classList.add('is-show'); });
    viewport.addEventListener('mouseleave', () => { macroHint && macroHint.classList.remove('is-show'); });

    // Open your zoom overlay when clicking "open" button
    // (your zoom overlay script uses clicking image to open; we trigger that)
    if(macroOpenBtn){
      macroOpenBtn.addEventListener('click', () => {
        if(activeImg) activeImg.click();
      });
    }

    // Init
    setTranslate(-index * slideWidth, false);
    updateUI();
    setActiveMedia(index);
    startAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlider);
  } else {
    setTimeout(initSlider, 50);
  }
})();


// ===============================
// ✅ VIDEO AUTOPLAY (safe version)
// ===============================
(function setupVideoAutoplay(){
  const videos = document.querySelectorAll('#track .slide video');
  if(!videos.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if(entry.isIntersecting){
        const p = video.play();
        if(p && typeof p.catch === "function") p.catch(()=>{});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }, { threshold: 0.5 });

  videos.forEach(v => observer.observe(v));
})();

(function setupVideoAutoplay(){
  const videos = root.querySelectorAll('.slide video');
  if(!videos.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }, { threshold: 0.5 });

  videos.forEach(v => observer.observe(v));

  // optional cleanup store (if needed later)
  root._gemVideoObserver = observer;
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rudraksha-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSlider() {
    const slider = document.getElementById('slider');
    const viewport = document.getElementById('viewport');
    const track = document.getElementById('track');
    const slides = Array.from(track?.children || []);
    const prevBtn = document.getElementById('prev');
    const nextBtn = document.getElementById('next');
    const dotsWrap = document.getElementById('dots');
    const thumbsWrap = document.getElementById('thumbs');

    if (!slider || !track || slides.length === 0) return; // Safety check

    let index = 0;
    let slideWidth = viewport.clientWidth;
    const total = slides.length;

    thumbsWrap.innerHTML = '';
    dotsWrap.innerHTML = '';

    const dots = [];
    const thumbs = [];

    // Create dots & thumbnails (one thumb per slide — images AND videos)
    slides.forEach((slide, i) => {
      // dot
      const dot = document.createElement('div');
      dot.className = 'dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(dot);
      dots.push(dot);

      // thumbnail
      const slideImg = slide.querySelector('img');
      const thumbSrc = slide.dataset.thumb || (slideImg ? slideImg.src : '');

      const wrap = document.createElement('div');
      wrap.className = 'thumb' + (i === 0 ? ' active' : '');

      const t = document.createElement('img');
      t.src = thumbSrc;
      t.alt = 'thumbnail ' + (i + 1);
      t.width = 84;
      t.height = 84;
      wrap.appendChild(t);

      if (slide.dataset.video === 'true') {
        const play = document.createElement('span');
        play.className = 'thumb-play';
        play.innerHTML = '<i class="fa-solid fa-play"></i>';
        wrap.appendChild(play);
      }

      wrap.addEventListener('click', () => goTo(i));
      thumbsWrap.appendChild(wrap);
      thumbs.push(wrap);
    });

    function setTranslate(x, animate = true) {
      track.style.transition = animate ? 'transform 720ms cubic-bezier(.22,.9,.32,1)' : 'none';
      track.style.transform = `translateX(${x}px)`;
    }

    function updateUI() {
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('active', i === index));
    }

    function clampIndex(i) {
      return ((i % total) + total) % total;
    }

    function goTo(i) {
      index = clampIndex(i);
      setTranslate(-index * slideWidth);
      updateUI();
      // restartAutoplay();
    }

    if (nextBtn) nextBtn.addEventListener('click', () => goTo(index + 1));
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(index - 1));

    // ✅ Drag / Swipe Handling
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let currentTranslate = 0;
    let isSwiping = false;

    function getEventXY(e) {
      if (e.type.startsWith('touch')) {
        const t = e.touches[0] || e.changedTouches[0];
        return { x: t.clientX, y: t.clientY };
      } else {
        return { x: e.clientX, y: e.clientY };
      }
    }

    function pointerDown(e) {
      if (e.type === 'mousedown' && e.button !== 0) return;
      const { x, y } = getEventXY(e);
      isDragging = true;
      isSwiping = false;
      startX = x;
      startY = y;
      slider.classList.add('grabbing');
      track.style.transition = 'none';
      pauseAutoplay();
      e.preventDefault?.();
    }

    function pointerMove(e) {
      if (!isDragging) return;
      const { x, y } = getEventXY(e);
      const dx = x - startX;
      const dy = y - startY;

      if (!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 5) {
        isSwiping = true;
      }

      if (isSwiping) {
        e.preventDefault?.();
        currentTranslate = -index * slideWidth + dx;
        setTranslate(currentTranslate, false);
      }
    }

    function pointerUp(e) {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove('grabbing');

      if (!isSwiping) {
        // restartAutoplay();
        return;
      }

      const { x } = getEventXY(e);
      const moved = x - startX;
      const threshold = Math.max(60, slideWidth * 0.15);

      if (moved > threshold) index -= 1;
      else if (moved < -threshold) index += 1;

      goTo(index);
    }

    track.addEventListener('mousedown', pointerDown);
    window.addEventListener('mousemove', pointerMove);
    window.addEventListener('mouseup', pointerUp);

    track.addEventListener('touchstart', pointerDown, { passive: true });
    track.addEventListener('touchmove', pointerMove, { passive: false });
    track.addEventListener('touchend', pointerUp);
    track.addEventListener('touchcancel', pointerUp);

    // Resize
    window.addEventListener('resize', () => {
      slideWidth = viewport.clientWidth;
      setTranslate(-index * slideWidth, false);
    });

    // Autoplay
    const AUTOPLAY_DELAY = 3000;
    let autoplayId = null, resumeTimeout = null;

    function startAutoplay() {
      if (autoplayId) return;
      autoplayId = setInterval(() => goTo(index + 1), AUTOPLAY_DELAY);
    }

    function pauseAutoplay() {
      if (autoplayId) { clearInterval(autoplayId); autoplayId = null; }
      if (resumeTimeout) { clearTimeout(resumeTimeout); }
    }

    function restartAutoplay(delay = 1200) {
      pauseAutoplay();
      resumeTimeout = setTimeout(() => startAutoplay(), delay);
    }

    slider.addEventListener('mouseenter', pauseAutoplay);
    // slider.addEventListener('mouseleave', () => restartAutoplay(700));

    // Init
    setTranslate(-index * slideWidth, false);
    updateUI();
    //startAutoplay();
  }

  // Shopify-safe DOM ready check
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlider);
  } else {
    setTimeout(initSlider, 50);
  }
})();


// === FULL ZOOM FEATURE ===
document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("zoomOverlay");
  const zoomedImg = document.getElementById("zoomedImage");
  if (!overlay || !zoomedImg) return;
  const closeBtn = overlay.querySelector(".zoom-close");
  const leftBtn = overlay.querySelector(".zoom-arrow.left");
  const rightBtn = overlay.querySelector(".zoom-arrow.right");
  const slides = Array.from(document.querySelectorAll("#track .slide img"));

  if (!slides.length) return;

  let currentIndex = 0;
  let zoomed = false;
  let isDragging = false;
  let startX = 0, startY = 0;
  let translateX = 0, translateY = 0;
  let currentTranslateX = 0, currentTranslateY = 0;

  function openZoom(index) {
    currentIndex = index;
    zoomedImg.src = slides[index].src;
    overlay.classList.add("active");
    zoomed = false;
    resetTransform();
  }

  function closeZoom() {
    overlay.classList.remove("active");
    zoomed = false;
    resetTransform();
  }

  function showNext(dir = 1) {
    currentIndex = (currentIndex + dir + slides.length) % slides.length;
    zoomedImg.src = slides[currentIndex].src;
    resetTransform();
  }

  function resetTransform() {
    zoomedImg.style.transform = "scale(1)";
    zoomedImg.classList.remove("zoomed");
    zoomed = false;
    translateX = translateY = 0;
    currentTranslateX = currentTranslateY = 0;
  }

  slides.forEach((img, i) => {
    img.addEventListener("click", () => openZoom(i));
  });

  closeBtn.addEventListener("click", closeZoom);
  leftBtn.addEventListener("click", () => showNext(-1));
  rightBtn.addEventListener("click", () => showNext(1));

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeZoom();
  });

  document.addEventListener("keydown", (e) => {
    if (!overlay.classList.contains("active")) return;
    if (e.key === "Escape") closeZoom();
    if (e.key === "ArrowRight") showNext(1);
    if (e.key === "ArrowLeft") showNext(-1);
  });

  zoomedImg.addEventListener("click", () => {
    if (!zoomed) {
      zoomed = true;
      zoomedImg.classList.add("zoomed");
      zoomedImg.style.transform = `scale(2) translate(0px, 0px)`;
    } else {
      resetTransform();
    }
  });

  function startDrag(e) {
    if (!zoomed) return;
    isDragging = true;
    const pos = getXY(e);
    startX = pos.x - currentTranslateX;
    startY = pos.y - currentTranslateY;
    zoomedImg.style.cursor = "grabbing";
  }

  function duringDrag(e) {
    if (!isDragging || !zoomed) return;
    e.preventDefault();
    const pos = getXY(e);
    translateX = pos.x - startX;
    translateY = pos.y - startY;
    zoomedImg.style.transform = `scale(2) translate(${translateX / 2}px, ${translateY / 2}px)`;
  }

  function endDrag() {
    if (!isDragging) return;
    isDragging = false;
    zoomedImg.style.cursor = "grab";
    currentTranslateX = translateX;
    currentTranslateY = translateY;
  }

  function getXY(e) {
    if (e.touches && e.touches[0]) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    return { x: e.clientX, y: e.clientY };
  }

  zoomedImg.addEventListener("mousedown", startDrag);
  window.addEventListener("mousemove", duringDrag);
  window.addEventListener("mouseup", endDrag);
  zoomedImg.addEventListener("touchstart", startDrag);
  zoomedImg.addEventListener("touchmove", duringDrag, { passive: false });
  zoomedImg.addEventListener("touchend", endDrag);

  let swipeStart = 0, swipeEnd = 0;
  overlay.addEventListener("touchstart", (e) => { swipeStart = e.touches[0].clientX; });
  overlay.addEventListener("touchend", (e) => {
    swipeEnd = e.changedTouches[0].clientX;
    const diff = swipeEnd - swipeStart;
    if (Math.abs(diff) > 50) {
      showNext(diff < 0 ? 1 : -1);
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zooming-feature-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("zoomOverlay");
  const zoomedImg = document.getElementById("zoomedImage");
  const closeBtn = overlay.querySelector(".customzoomer-zoom-close");
  const leftBtn = overlay.querySelector(".customzoomer-zoom-nav.customzoomer-left");
  const rightBtn = overlay.querySelector(".customzoomer-zoom-nav.customzoomer-right");
  const imageContainer = overlay.querySelector(".customzoomer-zoom-image-container");
  const slides = Array.from(document.querySelectorAll("#track .slide img"));
  if (!slides.length) return;

  let currentIndex = 0;
  let isZoomed = false;
  let translateX = 0, translateY = 0;
  let startX = 0, startY = 0;
  let touchStartX = 0, touchStartY = 0;
  let touchCurrentX = 0, touchCurrentY = 0;
  let initialScale = 1;
  let lastTapTime = 0;
  let lastTapX = 0;
  let lastTapY = 0;

  function clampPan() {
    const rect = imageContainer.getBoundingClientRect();
    const scale = initialScale;
    const minX = rect.width * (1 - scale) / 2;
    const maxX = -minX;
    const minY = rect.height * (1 - scale) / 2;
    const maxY = -minY;
    translateX = Math.max(minX, Math.min(maxX, translateX));
    translateY = Math.max(minY, Math.min(maxY, translateY));
  }

  function adaptButtonColors() {
    if (zoomedImg.naturalWidth === 0 || zoomedImg.naturalHeight === 0 || !zoomedImg.complete) return;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = zoomedImg.naturalWidth;
    canvas.height = zoomedImg.naturalHeight;
    ctx.drawImage(zoomedImg, 0, 0);
    const x = Math.floor(canvas.width / 2);
    const y = Math.floor(canvas.height * 0.9);
    const data = ctx.getImageData(x, y, 1, 1).data;
    const r = data[0] / 255;
    const g = data[1] / 255;
    const b = data[2] / 255;
    const lum = 0.299 * r + 0.587 * g + 0.114 * b;
    const buttons = document.querySelectorAll('.customzoomer-zoom-nav, .customzoomer-zoom-close');
    if (lum > 0.5) {
      // Light background: dark button bg, white text
      buttons.forEach(btn => {
        btn.style.background = 'rgba(0,0,0,0.8)';
        btn.style.color = '#fff';
        btn.style.borderColor = 'rgba(255,255,255,0.3)';
      });
    } else {
      // Dark background: light button bg, black text
      buttons.forEach(btn => {
        btn.style.background = 'rgba(255,255,255,0.8)';
        btn.style.color = '#000';
        btn.style.borderColor = 'rgba(0,0,0,0.3)';
      });
    }
  }

  function openZoom(index) {
    currentIndex = index;
    zoomedImg.onload = function() {
      adaptButtonColors();
    };
    zoomedImg.src = slides[index].src;
    overlay.classList.add("active");
    resetZoom();
  }

  function closeZoom() {
    overlay.classList.remove("active");
    resetZoom();
  }

  function resetZoom() {
    isZoomed = false;
    initialScale = 1;
    translateX = translateY = 0;
    imageContainer.style.cursor = 'grab';
    zoomedImg.style.transformOrigin = 'center center';
    updateTransform();
  }

  function updateTransform() {
    zoomedImg.style.transform = `scale(${initialScale}) translate(${translateX}px, ${translateY}px)`;
  }

  function zoomAtPoint(clientX, clientY, scale) {
    const rect = imageContainer.getBoundingClientRect();
    const x = (clientX - rect.left) / rect.width;
    const y = (clientY - rect.top) / rect.height;
    zoomedImg.style.transformOrigin = `${x * 100}% ${y * 100}%`;
    initialScale = scale;
    updateTransform();
  }

  function toggleZoom(clientX, clientY) {
    const newScale = isZoomed ? 1 : 2;
    if (newScale === 1) {
      translateX = 0;
      translateY = 0;
    }
    zoomAtPoint(clientX, clientY, newScale);
    isZoomed = (newScale > 1);
    imageContainer.style.cursor = isZoomed ? 'grab' : 'default';
    if (isZoomed) clampPan();
    // Ensure button colors are adapted after zoom
    setTimeout(adaptButtonColors, 100);
  }

  let isDragging = false;

  // Double click for mouse
  zoomedImg.addEventListener("dblclick", (e) => {
    e.stopPropagation();
    toggleZoom(e.clientX, e.clientY);
  });

  // Mouse drag to pan when zoomed
  imageContainer.addEventListener("mousedown", (e) => {
    if (!isZoomed || e.button !== 0) return;
    e.preventDefault();
    isDragging = true;
    startX = e.clientX - translateX;
    startY = e.clientY - translateY;
    imageContainer.style.cursor = "grabbing";

    function onMove(ev) {
      if (!isDragging) return;
      ev.preventDefault();
      translateX = ev.clientX - startX;
      translateY = ev.clientY - startY;
      clampPan();
      updateTransform();
    }

    function onUp(ev) {
      isDragging = false;
      imageContainer.style.cursor = "grab";
      clampPan();
      updateTransform();
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    }

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  });

  // Touch handling for pan, swipe, and double tap
  imageContainer.addEventListener("touchstart", (e) => {
    if (e.touches.length > 1) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchCurrentX = touchStartX;
    touchCurrentY = touchStartY;
    if (isZoomed) {
      startX = touchStartX - translateX;
      startY = touchStartY - translateY;
      isDragging = true;
      imageContainer.style.cursor = "grabbing";
    }
  }, { passive: false });

  imageContainer.addEventListener("touchmove", (e) => {
    if (e.touches.length > 1) return;
    e.preventDefault();
    touchCurrentX = e.touches[0].clientX;
    touchCurrentY = e.touches[0].clientY;
    const dx = touchCurrentX - touchStartX;
    const dy = touchCurrentY - touchStartY;

    if (isZoomed && isDragging) {
      translateX = touchCurrentX - startX;
      translateY = touchCurrentY - startY;
      clampPan();
      updateTransform();
    }
  }, { passive: false });

  imageContainer.addEventListener("touchend", (e) => {
    if (e.changedTouches.length !== 1) return;
    const touch = e.changedTouches[0];
    touchCurrentX = touch.clientX;
    touchCurrentY = touch.clientY;
    const dx = touchCurrentX - touchStartX;
    const dy = touchCurrentY - touchStartY;
    const now = Date.now();
    if (isDragging) {
      isDragging = false;
      imageContainer.style.cursor = "grab";
      clampPan();
      updateTransform();
      return;
    }
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      // Swipe navigation when not zoomed
      const dir = dx > 0 ? -1 : 1;
      showNext(dir);
      return;
    }
    if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
      // Potential tap
      if (now - lastTapTime < 300 &&
          Math.abs(touch.clientX - lastTapX) < 20 &&
          Math.abs(touch.clientY - lastTapY) < 20) {
        // Double tap
        toggleZoom(touch.clientX, touch.clientY);
      }
      // Update last tap
      lastTapTime = now;
      lastTapX = touch.clientX;
      lastTapY = touch.clientY;
    }
  }, { passive: false });

  function showNext(dir = 1) {
    currentIndex = (currentIndex + dir + slides.length) % slides.length;
    // Smooth transition
    zoomedImg.style.transition = 'opacity 0.3s ease';
    zoomedImg.style.opacity = '0';
    setTimeout(() => {
      zoomedImg.onload = function() {
        adaptButtonColors();
      };
      zoomedImg.src = slides[currentIndex].src;
      resetZoom();
      zoomedImg.style.opacity = '1';
      zoomedImg.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    }, 150);
  }

  slides.forEach((img, i) => {
    img.addEventListener("click", () => openZoom(i));
  });

  closeBtn.addEventListener("click", closeZoom);
  leftBtn.addEventListener("click", () => showNext(-1));
  rightBtn.addEventListener("click", () => showNext(1));

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeZoom();
  });

  // Prevent context menu on long press
  imageContainer.addEventListener("contextmenu", (e) => e.preventDefault());

  document.addEventListener("keydown", (e) => {
    if (!overlay.classList.contains("active")) return;
    if (e.key === "Escape") closeZoom();
    if (e.key === "ArrowRight") showNext(1);
    if (e.key === "ArrowLeft") showNext(-1);
  });
});
  } catch(e) { console.error(e); }
})();

})();
